export default __webpack_public_path__ + "static/media/edducation.a0c5e5e9.png";